import { useEffect, useState } from "react";
// Import React FilePond
import FilePondPluginImageExifOrientation from "filepond-plugin-image-exif-orientation";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
import { FilePond, registerPlugin } from "react-filepond";

// Import the plugin code
import { Box } from "@mui/material";
import FilePondPluginImageResize from "filepond-plugin-image-resize";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import { TailSpin } from "react-loader-spinner";
import { ADD_PAIEMENT, LISTE_OPERATEUR } from "../../Utils/constant";
import { store } from "../../services/service";
import { useGlobalStore } from "../../store/store";
import { useVerifyPaiementStore } from "../../store/verifyPaiementStore";
import { SubmitButton } from "../Widget/SubmitButton";
import { ValidateMessage } from "../Widget/ValidateMessage";

import { AlertCircle, Repeat, XCircle } from "lucide-react";
import cash from "../../assets/images/cash.png";
import moov from "../../assets/images/moov-money.png";
import momo from "../../assets/images/mtn-mooney.png";
import orange from "../../assets/images/om.png";
import visa from "../../assets/images/visa.png";
import wave from "../../assets/images/wave.png";
import PaymentValidationWaiting from "../Widget/EnAttentPaiement";

// Register the plugins
registerPlugin(
  FilePondPluginImageExifOrientation,
  FilePondPluginImagePreview,
  FilePondPluginImageResize,
);

export const CollectePaiement = ({ handleNext, numeroTicket }) => {
  const [filesRecuPaiement, setFilesRecuPaiement] = useState([]);
  const [paiementChoix, setPaiementChoix] = useState("MOMO");
  const [paiementRef, setPaiementRef] = useState(null);
  const [paiementStatus, setPaiementStatus] = useState("ATTENTE_DE_VALIDATION");
  const [loadingUpload, setLoadingUpload] = useState(false);
  const [fichierCreation, setFichierCreation] = useState("");
  const [paiementError, setPaiementError] = useState(null);
  const [msg, setMsg] = useState(null);

  const handleFileInput = (e) => {
    const fileUploaded = e.target.files[0];

    if (fileUploaded || fileUploaded !== undefined) {
      setFichierCreation(fileUploaded);
    }
  };

  const handleUpdateRecu = (fileItems) => {
    const newFiles = fileItems.map((fileItem) => fileItem.file);
    setFilesRecuPaiement(newFiles);
  };
  const verify = useVerifyPaiementStore();
  const isFree = useVerifyPaiementStore();
  const moyensPaiement = useGlobalStore();

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  useEffect(() => {
    if (verify?.data?.donnee?.titre === "ATTENTE_DE_VALIDATION") {
      const interval = setInterval(() => {
        verify.verification(paiementRef);
        setPaiementStatus(verify?.data?.donnee?.titre);
      }, 2000);
      return () => clearInterval(interval);
    }

    verify?.data?.donnee?.titre === "ECHEC"
      ? setIsSubmit(false)
      : verify?.data?.donnee?.titre === "SUCCES"
        ? setIsSubmit(null)
        : setIsSubmit(false);

    verify?.data?.donnee?.titre === "SUCCES" && setLoadingUpload(null);

    if (verify?.data?.donnee?.titre === "ECHEC" && paiementRef != null) {
      setPaiementError(verify?.data?.donnee?.message);
    }
  }, [paiementRef, verify, paiementStatus]);

  useEffect(() => {
    isFree.checking(numeroTicket);
    moyensPaiement.operateurs(LISTE_OPERATEUR);
  }, []);

  console.log(isFree);
  const [isSubmit, setIsSubmit] = useState(false);

  const resetStates = () => {
    setPaiementRef(null);
    setPaiementError(null);
  };

  const submit = (data) => {
    setIsSubmit(true);
    const requestData = {
      ...data,
      numeroTicket: numeroTicket,
      recuPaiement: filesRecuPaiement[0],
      typePaiement: "PAIEMENT_EQUIPEMENT",
      codeOperateur: paiementChoix,
    };
    store(ADD_PAIEMENT, "multipart/form-data", requestData)
      .then((res) => {
        setPaiementRef(res.data.donnee.reference);
        setPaiementStatus(res.data.donnee.titre);
        if (
          paiementChoix === "WAVE_SKAN" ||
          paiementChoix === "CARTE_BANCAIRE_CINETPAY_SKAN"
        ) {
          window.open(res.data.donnee.message, "_blank", "noopener,noreferrer");
        }
        res.data.donnee.titre === "ECHEC"
          ? setIsSubmit(false)
          : setIsSubmit(true);
        verify.verification(res.data.donnee.reference);
        if (res.data.donnee.titre === "ECHEC_PAIEMENT") {
          setMsg(res.data.donnee.message);
        }
      })
      .catch((err) => {
        setIsSubmit(false);
        toast.error(err.response.data.donnee);
      });
  };

  const image = [
    {
      code: "WAVE_SKAN",
      image: wave,
    },
    {
      code: "OM_SKAN",
      image: orange,
    },
    {
      code: "MOOV_SKAN",
      image: moov,
    },
    {
      code: "MOMO",
      image: momo,
    },
    {
      code: "CARTE_BANCAIRE_CINETPAY_SKAN",
      image: visa,
    },
    {
      code: "CASH",
      image: cash,
    },
  ];

  return (
    <>
      <div className="w-full flex flex-col  mt-6">
        {isFree?.isloading && isFree?.isFree === null ? (
          <div className="w-full my-4 flex items-center justify-center">
            <TailSpin
              height="40"
              width="40"
              color="#000"
              ariaLabel="tail-spin-loading"
              radius="2"
              wrapperStyle={{}}
              wrapperClass=""
              visible={isFree?.isloading}
            />
          </div>
        ) : isFree?.isFree !== "error" ? (
          <>
            {verify?.data?.donnee?.titre === "SUCCES" && paiementRef != null ? (
              <ValidateMessage texte={"Paiement validé"} />
            ) : isFree?.isFree?.donnee ? (
              <ValidateMessage texte={"Paiement validé"} />
            ) : paiementChoix !== "CASH" &&
              (verify?.data?.donnee?.titre === "ATTENTE_DE_VALIDATION" ||
                (verify?.data === null && verify?.loading)) &&
              paiementRef != null ? (
              <PaymentValidationWaiting
                handle={resetStates}
                image={image.find((logo) => logo.code === paiementChoix)?.image}
              />
            ) : paiementError ? (
              <div>
                <div className="bg-white rounded-2xl border p-6 mb-6">
                  <div className="text-center">
                    <div className="relative">
                      <div className="w-24 h-24 bg-gradient-to-r from-red-500 to-orange-500 rounded-full flex items-center justify-center mx-auto mb-6">
                        <XCircle className="w-12 h-12 text-white" />
                      </div>
                    </div>

                    <h1 className="text-2xl font-bold text-red-600 mb-2">
                      Échec du paiement
                    </h1>
                    <p className="text-gray-600 mb-4">
                      Votre transaction n'a pas pu être finalisée
                    </p>
                    <p className="text-red-500 mb-4">
                      {paiementError === "null"
                        ? "Transaction rejété"
                        : paiementError}
                    </p>
                    <div
                      onClick={resetStates}
                      className="cursor-pointer inline-flex items-center px-4 py-2 bg-red-100 text-red-800 rounded-full text-sm font-medium"
                    >
                      <Repeat className="w-4 h-4 mr-2" />
                      Réessayer
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <>
                <form
                  onSubmit={handleSubmit(submit)}
                  className="shadow-sm border rounded w-full p-8"
                >
                  <label className="form-control w-full">
                    <h1 class="text-amber-500 font-mtn text-2xl font-semibold tracking-tight">
                      Collecte de paiement
                    </h1>
                    <p className="text-sm my-3">
                      Choisisser un moyen de paiement
                    </p>
                    <div className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-3 gap-3">
                      {moyensPaiement?.operateur?.donnee
                        ?.filter(
                          (moyenPaiement) => moyenPaiement.typeEtat === "ACTIF",
                        )
                        .map((provider) => (
                          <span
                            key={provider.id}
                            onClick={() => setPaiementChoix(provider.code)}
                            className={`cursor-pointer px-2 py-1 flex items-center justify-center rounded-xl border transition-all duration-200 hover:scale-105 ${
                              paiementChoix === provider.code
                                ? `border-2 border-black`
                                : "border-gray-200 hover:border-gray-300"
                            }`}
                          >
                            <div className="flex flex-col items-center justify-center gap-3">
                              <img
                                className="rounded-full h-8 w-8"
                                src={
                                  image.find(
                                    (logo) => logo.code === provider.code,
                                  )?.image
                                }
                                alt=""
                                srcset=""
                              />
                              <p className={`font-medium text-xs `}>
                                {provider.designation}
                              </p>
                            </div>
                          </span>
                        ))}
                    </div>
                  </label>
                  {paiementChoix !== "CASH" ? (
                    <>
                      {paiementChoix !== "CARTE_BANCAIRE_CINETPAY_SKAN" &&
                      paiementChoix !== "WAVE_SKAN" ? (
                        <label className="form-control w-full">
                          <div className="label -mb-1">
                            <span className="label-text font-medium ">
                              Numero de telephone{" "}
                              <span className="text-red-500">*</span>
                            </span>
                          </div>
                          <input
                            {...register("numeroMtn", { required: true })}
                            type="text"
                            placeholder="05 000 000 00"
                            className="input input-bordered text-gray-500 w-full  h-10 text-sm font-semibold"
                          />
                        </label>
                      ) : null}

                      {paiementChoix === "OM_SKAN" ? (
                        <label className="form-control w-full">
                          <div className="label -mb-1">
                            <span className="label-text font-medium ">
                              Code de securité{" "}
                              <span className="text-red-500">*</span>
                            </span>
                          </div>
                          <input
                            {...register("token", { required: true })}
                            type="text"
                            placeholder="Taper #144*82# pour obtenir un code"
                            className="input input-bordered text-gray-500 w-full  h-10 text-sm font-semibold"
                          />
                        </label>
                      ) : null}
                    </>
                  ) : (
                    <label className="form-control  w-full">
                      <div className="label -mb-1">
                        <span className="label-text ">Télécharger le reçu</span>
                      </div>

                      <div className="">
                        <FilePond
                          files={filesRecuPaiement}
                          onupdatefiles={handleUpdateRecu}
                          allowImageResize="true"
                          acceptedFileTypes={["application/pdf"]}
                          allowMultiple={false}
                          labelIdle="Importer reçu de paiement"
                        />
                      </div>
                    </label>
                  )}
                  <div className="mr-auto w-full">
                    <SubmitButton
                      isSubmit={isSubmit}
                      label={"faire le paiement"}
                    />
                  </div>
                </form>
              </>
            )}
          </>
        ) : (
          <div className="bg-white rounded-2xl border p-6 mb-6">
            <div className="text-center">
              <div className="relative">
                <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-6">
                  <AlertCircle className="w-6 h-6 text-red-500" />
                </div>
              </div>

              <h1 className="text-xl font-bold text-red-500 mb-2 font-mtn">
                Aucun PBO disponible
              </h1>
              <p className="text-gray-600 mb-4">
                {isFree?.msg
                  ? isFree?.msg
                  : "Désolé il n y a plus de brin disponible pour cette intention"}
              </p>
            </div>
          </div>
        )}

        <div className="w-full mt-4">
          <hr />
          <div
            className="flex mt-4"
            sx={{ display: "flex", flexDirection: "row", pt: 2 }}
          >
            <Box sx={{ flex: "1 1 auto" }} />
            <span
              disabled={
                loadingUpload === null &&
                paiementChoix !== "CASH" &&
                paiementChoix !== "CARTE_BANCAIRE_CINETPAY_SKAN"
                  ? false
                  : paiementRef !== null && paiementChoix === "CASH"
                    ? false
                    : isFree?.isFree?.donnee
                      ? false
                      : true
              }
              className={`bg-[#ffcb05] btn btn-sm py-1 px-2 font-medium rounded-lg `}
              onClick={handleNext}
            >
              Poursuivre
            </span>
          </div>
        </div>
      </div>
    </>
  );
};
